import React from 'react';
import {
  IconCalendar,
  IconMessage,
  IconDatabase,
  IconShield,
  IconBook,
  IconRocket,
} from '@tabler/icons-react';

const ICON_MAP = {
  calendar: IconCalendar,
  chat: IconMessage,
  database: IconDatabase,
  shield: IconShield,
  book: IconBook,
  rocket: IconRocket,
};

const PlanCard = ({ step, title, description, icon }) => {
  const Icon = ICON_MAP[icon] || IconRocket;

  return (
    <div className="awc-plan">
      <div className="awc-plan__badge">{step}</div>
      <div className="awc-plan__content">
        <h4>{title}</h4>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default PlanCard;
